var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "1000"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Grupo ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Origem",
      "item-text": "descricao",
      "item-value": "id",
      "dense": "",
      "outlined": "",
      "return-object": "",
      "disabled": _vm.edit,
      "items": _vm.form.lists.origens,
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.origem,
      callback: function ($$v) {
        _vm.$set(_vm.content, "origem", $$v);
      },
      expression: "content.origem"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do Grupo",
      "maxLength": "40",
      "counter": "40",
      "dense": "",
      "outlined": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 40);
      }]
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Descrição do Grupo",
      "maxlength": "250",
      "counter": "250",
      "rows": "3",
      "dense": "",
      "outlined": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 250);
      }]
    },
    model: {
      value: _vm.content.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "descricao", $$v);
      },
      expression: "content.descricao"
    }
  })], 1)], 1), _vm.isEscola ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": _vm.isProfessor || _vm.isTecnicoFormador ? 3 : 4
    }
  }, [_c('v-select', {
    attrs: {
      "item-text": "nome",
      "item-value": "codigo",
      "label": "GRE",
      "dense": "",
      "outlined": "",
      "items": _vm.form.lists.gres
    },
    model: {
      value: _vm.content.greId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "greId", $$v);
      },
      expression: "content.greId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": _vm.isProfessor || _vm.isTecnicoFormador ? 3 : 4
    }
  }, [_c('v-autocomplete', {
    key: _vm.escolaKey,
    attrs: {
      "item-text": "nome",
      "item-value": "codigo",
      "label": "Escola",
      "dense": "",
      "outlined": "",
      "multiple": "",
      "items": _vm.form.lists.escolas
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref) {
        var item = _ref.item,
          index = _ref.index;
        return [index === 0 && _vm.content.escolaId && _vm.content.escolaId.length > 2 ? _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.content.escolaId.length) + " selecionados ")]) : !_vm.content.escolaId || _vm.content.escolaId.length <= 2 ? _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(item.nome) + " ")]) : _vm._e()];
      }
    }, {
      key: "prepend-item",
      fn: function () {
        return [_c('v-list-item', {
          attrs: {
            "ripple": ""
          },
          on: {
            "mousedown": function ($event) {
              $event.preventDefault();
            },
            "click": _vm.toggleTodasEscolas
          }
        }, [_c('v-list-item-action', [_c('v-icon', {
          attrs: {
            "color": _vm.content.escolaId && _vm.content.escolaId.length > 0 ? 'primary' : ''
          }
        }, [_vm._v(" " + _vm._s(_vm.iconTodasEscolas) + " ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Selecionar Todas")])], 1)], 1), _c('v-divider', {
          staticClass: "mt-2"
        })];
      },
      proxy: true
    }], null, false, 359282069),
    model: {
      value: _vm.content.escolaId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "escolaId", $$v);
      },
      expression: "content.escolaId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": _vm.isProfessor || _vm.isTecnicoFormador ? 3 : 4
    }
  }, [_c('v-select', {
    attrs: {
      "item-text": "nome",
      "item-value": "id",
      "label": "Função",
      "dense": "",
      "outlined": "",
      "items": _vm.form.lists.funcoes
    },
    model: {
      value: _vm.content.funcaoId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "funcaoId", $$v);
      },
      expression: "content.funcaoId"
    }
  })], 1), _vm.isProfessor || _vm.isTecnicoFormador ? _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    key: _vm.disciplinaKey,
    attrs: {
      "item-text": "nomeDisciplina",
      "item-value": "id",
      "label": "Disciplina",
      "dense": "",
      "outlined": "",
      "multiple": "",
      "items": _vm.form.lists.disciplinas
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref2) {
        var item = _ref2.item,
          index = _ref2.index;
        return [index === 0 && _vm.content.disciplinaId && _vm.content.disciplinaId.length > 2 ? _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.content.disciplinaId.length) + " selecionados ")]) : !_vm.content.disciplinaId || _vm.content.disciplinaId.length <= 2 ? _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(item.nomeDisciplina) + " ")]) : _vm._e()];
      }
    }, {
      key: "prepend-item",
      fn: function () {
        return [_c('v-list-item', {
          attrs: {
            "ripple": ""
          },
          on: {
            "mousedown": function ($event) {
              $event.preventDefault();
            },
            "click": _vm.toggleTodasDisciplinas
          }
        }, [_c('v-list-item-action', [_c('v-icon', {
          attrs: {
            "color": _vm.content.disciplinaId && _vm.content.disciplinaId.length > 0 ? 'primary' : ''
          }
        }, [_vm._v(" " + _vm._s(_vm.iconTodasDisciplinas) + " ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Selecionar Todas")])], 1)], 1), _c('v-divider', {
          staticClass: "mt-2"
        })];
      },
      proxy: true
    }], null, false, 2218793506),
    model: {
      value: _vm.content.disciplinaId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "disciplinaId", $$v);
      },
      expression: "content.disciplinaId"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm.isGRE ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": _vm.isTecnicoFormador ? 3 : 4
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-text": "nome",
      "item-value": "codigo",
      "label": "GRE",
      "dense": "",
      "outlined": "",
      "items": _vm.form.lists.gres
    },
    model: {
      value: _vm.content.greId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "greId", $$v);
      },
      expression: "content.greId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": _vm.isTecnicoFormador ? 3 : 4
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-text": "nome",
      "item-value": "id",
      "label": "Setor",
      "dense": "",
      "outlined": "",
      "items": _vm.form.lists.setores
    },
    model: {
      value: _vm.content.setorId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "setorId", $$v);
      },
      expression: "content.setorId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": _vm.isTecnicoFormador ? 3 : 4
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-text": "nome",
      "item-value": "id",
      "label": "Função",
      "dense": "",
      "outlined": "",
      "items": _vm.form.lists.funcoes
    },
    model: {
      value: _vm.content.funcaoId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "funcaoId", $$v);
      },
      expression: "content.funcaoId"
    }
  })], 1), _vm.isTecnicoFormador ? _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    key: _vm.disciplinaKey,
    attrs: {
      "item-text": "nomeDisciplina",
      "item-value": "id",
      "label": "Disciplina",
      "dense": "",
      "outlined": "",
      "multiple": "",
      "items": _vm.form.lists.disciplinas
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref3) {
        var item = _ref3.item,
          index = _ref3.index;
        return [index === 0 && _vm.content.disciplinaId && _vm.content.disciplinaId.length > 2 ? _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.content.disciplinaId.length) + " selecionados ")]) : !_vm.content.disciplinaId || _vm.content.disciplinaId.length <= 2 ? _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(item.nomeDisciplina) + " ")]) : _vm._e()];
      }
    }, {
      key: "prepend-item",
      fn: function () {
        return [_c('v-list-item', {
          attrs: {
            "ripple": ""
          },
          on: {
            "mousedown": function ($event) {
              $event.preventDefault();
            },
            "click": _vm.toggleTodasDisciplinas
          }
        }, [_c('v-list-item-action', [_c('v-icon', {
          attrs: {
            "color": _vm.content.disciplinaId && _vm.content.disciplinaId.length > 0 ? 'primary' : ''
          }
        }, [_vm._v(" " + _vm._s(_vm.iconTodasDisciplinas) + " ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Selecionar Todas")])], 1)], 1), _c('v-divider', {
          staticClass: "mt-2"
        })];
      },
      proxy: true
    }], null, false, 2218793506),
    model: {
      value: _vm.content.disciplinaId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "disciplinaId", $$v);
      },
      expression: "content.disciplinaId"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm.isSEE ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": _vm.isTecnicoFormador ? 3 : 4
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-text": "nome",
      "item-value": "codigo",
      "label": "Secretaria Executiva",
      "dense": "",
      "outlined": "",
      "items": _vm.form.lists.secretarias
    },
    model: {
      value: _vm.content.secretariaId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "secretariaId", $$v);
      },
      expression: "content.secretariaId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": _vm.isTecnicoFormador ? 3 : 4
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-text": "nome",
      "item-value": "id",
      "label": "Setor",
      "dense": "",
      "outlined": "",
      "items": _vm.form.lists.setores
    },
    model: {
      value: _vm.content.setorId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "setorId", $$v);
      },
      expression: "content.setorId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": _vm.isTecnicoFormador ? 3 : 4
    }
  }, [_c('v-select', {
    attrs: {
      "item-text": "nome",
      "item-value": "id",
      "label": "Função",
      "dense": "",
      "outlined": "",
      "items": _vm.form.lists.funcoes
    },
    model: {
      value: _vm.content.funcaoId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "funcaoId", $$v);
      },
      expression: "content.funcaoId"
    }
  })], 1), _vm.isTecnicoFormador ? _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    key: _vm.disciplinaKey,
    attrs: {
      "item-text": "nomeDisciplina",
      "item-value": "id",
      "label": "Disciplina",
      "dense": "",
      "outlined": "",
      "multiple": "",
      "items": _vm.form.lists.disciplinas,
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref4) {
        var item = _ref4.item,
          index = _ref4.index;
        return [index === 0 && _vm.content.disciplinaId && _vm.content.disciplinaId.length > 2 ? _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.content.disciplinaId.length) + " selecionados ")]) : !_vm.content.disciplinaId || _vm.content.disciplinaId.length <= 2 ? _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(item.nomeDisciplina) + " ")]) : _vm._e()];
      }
    }, {
      key: "prepend-item",
      fn: function () {
        return [_c('v-list-item', {
          attrs: {
            "ripple": ""
          },
          on: {
            "mousedown": function ($event) {
              $event.preventDefault();
            },
            "click": _vm.toggleTodasDisciplinas
          }
        }, [_c('v-list-item-action', [_c('v-icon', {
          attrs: {
            "color": _vm.content.disciplinaId && _vm.content.disciplinaId.length > 0 ? 'primary' : ''
          }
        }, [_vm._v(" " + _vm._s(_vm.iconTodasDisciplinas) + " ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Selecionar Todas")])], 1)], 1), _c('v-divider', {
          staticClass: "mt-2"
        })];
      },
      proxy: true
    }], null, false, 2218793506),
    model: {
      value: _vm.content.disciplinaId,
      callback: function ($$v) {
        _vm.$set(_vm.content, "disciplinaId", $$v);
      },
      expression: "content.disciplinaId"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "btn-group text-center mb-5"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref5) {
        var on = _ref5.on,
          attrs = _ref5.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              return _vm.adicionarTodosUsuariosAoGrupo();
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-account-plus")])], 1)];
      }
    }], null, false, 702522041)
  }, [_c('span', [_vm._v("Incluir usuários em massa")])]), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref6) {
        var on = _ref6.on,
          attrs = _ref6.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              return _vm.dialogAdicionarUsuario.open();
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
      }
    }], null, false, 3880534886)
  }, [_c('span', [_vm._v("Incluir usuários")])])], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.content.usuarios,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.cpf`,
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s(_vm.$esconderCpf(item.cpf)) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref8) {
        var item = _ref8.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Remover",
            "icon": "mdi-trash-can-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.removerUsuario(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1)], 1)], 1) : _vm._e()], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": "Salvar"
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1), _vm.dialogAdicionarUsuario.visible ? _c('AdicionarUsuarioDialog', {
    attrs: {
      "visible": _vm.dialogAdicionarUsuario.visible,
      "content": _vm.dialogAdicionarUsuario.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogAdicionarUsuario.close();
      },
      "onSave": function ($event) {
        return _vm.adicionarUsuarioAoGrupo($event);
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }